import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPayoutIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.21212 19.279H14.8182C15.497 19.279 16.0303 18.7456 16.0303 18.0668V16.685C16.0303 16.5396 15.9333 16.4426 15.7879 16.4426C15.6424 16.4426 15.5455 16.5396 15.5455 16.685V18.0668C15.5455 18.479 15.2303 18.7941 14.8182 18.7941H2.21212C1.8 18.7941 1.48485 18.479 1.48485 18.0668V9.33956C1.48485 8.92744 1.8 8.61229 2.21212 8.61229H14.8182C15.2303 8.61229 15.5455 8.92744 15.5455 9.33956V10.8426C15.5455 10.988 15.6424 11.085 15.7879 11.085C15.9333 11.085 16.0303 10.988 16.0303 10.8426V9.33956C16.0303 8.66077 15.497 8.12744 14.8182 8.12744H2.21212C1.53333 8.12744 1 8.66077 1 9.33956V18.0668C1 18.7214 1.53333 19.279 2.21212 19.279Z",
			fill: "#1E63FF",
			stroke: "#1E63FF",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3939 11.7637C11.7151 11.7637 11.1818 12.297 11.1818 12.9758V14.4303C11.1818 15.1091 11.7151 15.6425 12.3939 15.6425H15.7878C16.4666 15.6425 16.9999 15.1091 16.9999 14.4303V12.9758C16.9999 12.297 16.4666 11.7637 15.7878 11.7637H12.3939ZM16.5151 12.9758V14.4303C16.5151 14.8425 16.1999 15.1576 15.7878 15.1576H12.3939C11.9818 15.1576 11.6666 14.8425 11.6666 14.4303V12.9758C11.6666 12.5637 11.9818 12.2485 12.3939 12.2485H15.7878C16.1999 12.2485 16.5151 12.5637 16.5151 12.9758Z",
			fill: "#1E63FF",
			stroke: "#1E63FF",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1212 14.4301C13.5229 14.4301 13.8485 14.1045 13.8485 13.7029C13.8485 13.3012 13.5229 12.9756 13.1212 12.9756C12.7195 12.9756 12.3939 13.3012 12.3939 13.7029C12.3939 14.1045 12.7195 14.4301 13.1212 14.4301Z",
			fill: "#1E63FF",
			stroke: "#1E63FF",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.98794 7.15758C3.08491 7.25455 3.23036 7.25455 3.32733 7.15758C3.4243 7.06061 3.4243 6.91515 3.32733 6.81818L1.84854 5.33939L5.60612 1.58182L11.2061 7.18182C11.2546 7.2303 11.3273 7.25455 11.3758 7.25455C11.4243 7.25455 11.497 7.2303 11.5455 7.18182C11.6425 7.08485 11.6425 6.93939 11.5455 6.84242L5.80006 1.07273C5.70309 0.975758 5.55763 0.975758 5.46066 1.07273L1.33945 5.1697C1.24248 5.26667 1.24248 5.41212 1.33945 5.50909L2.98794 7.15758Z",
			fill: "#1E63FF",
			stroke: "#1E63FF",
			strokeWidth: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4908 2.55157L9.94535 1.77581L12.9029 7.03642C12.9514 7.10915 13.0241 7.15763 13.1211 7.15763C13.1696 7.15763 13.1938 7.15763 13.2423 7.13339C13.3635 7.06066 13.412 6.91521 13.3393 6.79399L10.2605 1.31521C10.1878 1.19399 10.0423 1.16975 9.94535 1.21824L8.27262 2.11521C8.15141 2.18793 8.10292 2.33339 8.17565 2.4546C8.22413 2.55157 8.39383 2.60005 8.4908 2.55157Z",
			fill: "#1E63FF",
			stroke: "#1E63FF",
			strokeWidth: .3
		})
	]
});
export default SvgPayoutIcon;
